(function () {
  if (!window.__excludePublishers) return;

  var vendorSet = null;
  var handleSet = null;

  function normalize(value) {
    return String(value || '').toLowerCase().trim();
  }

  function initSets() {
    if (vendorSet) return;
    vendorSet = new Set((window.__excludedPublisherVendors || []).map(normalize));
    handleSet = new Set((window.__excludedPublisherHandles || []).map(normalize));
  }

  function isExcludedVendor(vendor) {
    initSets();
    var normalized = normalize(vendor);
    if (!normalized) return false;
    return vendorSet.has(normalized) || handleSet.has(normalized);
  }

  function isExcludedHandle(handle) {
    initSets();
    return handleSet.has(normalize(handle));
  }

  function removeExcludedNavLinks(root) {
    var scope = root || document;

    scope.querySelectorAll('a[href*="/collections/"], a[href*="/pages/"]').forEach(function (anchor) {
      var path = anchor.pathname || '';
      var collectionMatch = path.match(/\/collections\/([^/?#]+)/i);
      var pageMatch = path.match(/\/pages\/([^/?#]+)/i);
      var handle = collectionMatch ? collectionMatch[1] : pageMatch ? pageMatch[1] : '';

      if (handle && isExcludedHandle(handle)) {
        var listItem = anchor.closest('li');
        var column = anchor.closest('.mega-menu__col');
        if (listItem) {
          listItem.remove();
        } else if (column) {
          column.remove();
        } else {
          anchor.remove();
        }
        return;
      }

      var vendorText = anchor.textContent || '';
      if (vendorText && isExcludedVendor(vendorText)) {
        var vendorListItem = anchor.closest('li');
        var vendorColumn = anchor.closest('.mega-menu__col');
        if (vendorListItem) {
          vendorListItem.remove();
        } else if (vendorColumn) {
          vendorColumn.remove();
        } else {
          anchor.remove();
        }
      }
    });
  }

  function removeExcludedNodes(root) {
    var scope = root || document;

    scope.querySelectorAll('[data-vendor]').forEach(function (node) {
      if (node.closest('#product-grid[data-exclusion-pagination="true"]')) {
        return;
      }
      if (isExcludedVendor(node.getAttribute('data-vendor'))) {
        var gridItem = node.closest('.grid__item, .slider__slide, .product-card-wrapper, .card-wrapper');
        if (gridItem) {
          gridItem.remove();
        } else {
          node.remove();
        }
      }
    });

    scope.querySelectorAll('[data-publisher-handle]').forEach(function (node) {
      if (isExcludedHandle(node.getAttribute('data-publisher-handle'))) {
        node.remove();
      }
    });

    scope.querySelectorAll('.predictive-search__list-item[data-vendor]').forEach(function (node) {
      if (isExcludedVendor(node.getAttribute('data-vendor'))) {
        node.remove();
      }
    });
  }

  function guardExcludedPublisherPage() {
    if (!window.__publisherPageExcluded) return;

    var main = document.getElementById('MainContent');
    if (!main) return;

    main.innerHTML =
      '<div class="publisher-exclusion-blocked page-width" style="padding:5rem 1.5rem;text-align:center;">' +
      '<h1 class="h2">Page not found</h1>' +
      '<p>This content is not available in our catalog.</p>' +
      '<a href="/" class="button button--primary">Continue shopping</a>' +
      '</div>';
  }

  document.addEventListener('DOMContentLoaded', function () {
    guardExcludedPublisherPage();
    removeExcludedNodes(document);
    removeExcludedNavLinks(document);
  });

  document.addEventListener('product-grid:updated', function () {
    removeExcludedNodes(document.getElementById('ProductGridContainer') || document);
    removeExcludedNavLinks(document);
  });
})();
